/**
 * @ngdoc directives
 * @memberof mercury.directives
 * @name icon-user
 * @description Displays the User icon
 */
angular.module('mercury.directives.icon-user', [])
.directive('iconUser', function() {
  return {
    restrict: 'E',
    template: '<svg class="svg-icon-root" focusable="false" viewBox="0 0 24 24">' +
                '<g clip-path="url(#clip0_scaled)">' +
                '<path d="M12 13.5C15.7266 13.5 18.75 10.4766 18.75 6.75C18.75 3.02344 15.7266 0 12 0C8.27344 0 5.25 3.02344 5.25 6.75C5.25 10.4766 8.27344 13.5 12 13.5ZM18 15H15.4172C14.3766 15.4782 13.2188 15.75 12 15.75C10.7812 15.75 9.62812 15.4782 8.58281 15H6C2.68594 15 0 17.686 0 21V21.75C0 23.0012 1.00781 24 2.25 24H21.75C22.9922 24 24 23.0012 24 21.75V21C24 17.686 21.3141 15 18 15Z" />' +
                '</g>' +
                '<defs>' +
                '<clipPath id="clip0_scaled">' +
                '<rect width="24" height="24" fill="white"/>' +
                '</clipPath>' +
                '</defs>' +
              '</svg>',
    }
  })
